module.exports = __webpack_public_path__ + "static/media/image-rules-bonus.f19a40fb.svg";